import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b79c010")

_pushScopeId("data-v-0b79c010")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "患者一覧", -1)
const _hoisted_2 = {
  key: 0,
  class: "vue-content-center"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("読み込み中...")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_list_title_multiline = _resolveComponent("list-title-multiline")
  const _component_list_row = _resolveComponent("list-row")
  const _component_loading_message = _resolveComponent("loading-message")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, { class: "patient-list" }, {
    default: _withId(() => [
      _hoisted_1,
      _createVNode(_component_list_title_multiline, { titles: _ctx.titles }, null, 8, ["titles"]),
      _createVNode(_component_vue_y_scroll_area, null, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
            return (_openBlock(), _createBlock(_component_list_row, {
              key: row.patient.id,
              rowId: row.patient.id,
              columns: row.columns,
              searchWord: _ctx.searchWord,
              onClick: ($event: any) => (_ctx.$emit($event.emitType, row.patient))
            }, null, 8, ["rowId", "columns", "searchWord", "onClick"]))
          }), 128)),
          (!_ctx.delayed)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_loading_message, null, {
                  default: _withId(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})